import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

interface IHeroModuleInitData {

}

@ModuleName("HeroModule")
export class HeroModule implements AxInit {

    AxInit(init: IHeroModuleInitData): void {
        this.initScrollListener();
    }

    initScrollListener() {
        $(window).scroll(function () {
            let scroll = $(window).scrollTop();
            
            $(".ax-store-hero__background").css({
                filter: "blur(" + (scroll/25) + "px)"
            });
        });
    }
}